(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pdfView', {
            parent: 'application',
            url: '/documents/:uuid/view',
            data: {
                pageTitle: 'global.menu.pdfView'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/pdfView/pdfView.html',
                    controller: 'PdfViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pdfView');
                    return $translate.refresh();
                }],
                uuid: ['$stateParams', function($stateParams){
                    return $stateParams.uuid;
                }]
            }
        });
    }
})();
